import { Routes } from '@angular/router';
import { Layout } from 'src/app/core/layout/components/layout/layout';
import { Routes as AppRoutes } from 'src/app/core/routes/routes';
import { User } from 'src/app/features/user/pages/user/user';
import { Login } from 'src/app/core/auth/pages/login/login';
import { adminGuard, authGuard } from 'src/app/core/auth/guards/auth-guard';
import { permissionGuard } from 'src/app/core/auth/guards/permission-guard';
import { Businesses } from 'src/app/features/business/pages/businesses/businesses';
import { Offices } from 'src/app/features/business/pages/offices/offices';
import { UserForm } from 'src/app/features/user/pages/user-form/user-form';
import { OfficeForm } from 'src/app/features/business/pages/office-form/office-form';
import { Forms } from '@features/forms/pages/forms/forms';
import { Dashboard } from './features/dashboard/pages/dashboard/dashboard';
import { BusinessGroupForm } from '@features/business/pages/business-group-form/business-group-form';
import { BusinessForm } from '@features/business/pages/business-form/business-form';
import { RecoverPassword } from '@core/auth/pages/recover-password/recover-password';
import { OfficeBulkForm } from '@features/business/pages/office-bulk-form/office-bulk-form';
import { EmissionsFactors } from '@features/emissions/pages/emissions-factors/emissions-factors';
import { UserPermission } from '@core/auth/services/auth-service';
import { EmissionsSources } from '@features/emissions/pages/emissions-sources/emissions-sources.component';
import { Results } from '@features/reports/pages/results/results';
import { ResultsByMonth } from '@features/reports/pages/results-by-month/results-by-month';
import { unsavedChangesGuard } from '@features/forms/guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: AppRoutes.loginPage,
    component: Login
  },
  {
    path: AppRoutes.recoverPasswordPage,
    component: RecoverPassword
  },
  {
    path: '',
    component: Layout,
    children: [
      {
        path: AppRoutes.dashboardPage,
        component: Dashboard,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.usersPage,
        component: User,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.usersAddPage,
        component: UserForm,
        canActivate: [authGuard, adminGuard]
      },
      {
        path: AppRoutes.usersEditPage,
        component: UserForm,
        canActivate: [authGuard, adminGuard]
      },
      {
        path: AppRoutes.businessesPage,
        component: Businesses,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.businessesAddGroupPage,
        component: BusinessGroupForm,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.businessesEditGroupPage,
        component: BusinessGroupForm,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.businessesAddPage,
        component: BusinessForm,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.businessesEditPage,
        component: BusinessForm,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.officesPage,
        component: Offices,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.officesBulkUploadPage,
        component: OfficeBulkForm,
        canActivate: [authGuard, permissionGuard],
        data: { permissions: [UserPermission.CREATE_OFFICE] }
      },
      {
        path: AppRoutes.officesAddPage,
        component: OfficeForm,
        canActivate: [authGuard, permissionGuard],
        data: { permissions: [UserPermission.CREATE_OFFICE] }
      },
      {
        path: AppRoutes.officesEditPage,
        component: OfficeForm,
        canActivate: [authGuard, permissionGuard],
        data: { permissions: [UserPermission.UPDATE_OFFICE] }
      },
      {
        path: AppRoutes.formsPage,
        component: Forms,
        canActivate: [authGuard],
        canDeactivate: [unsavedChangesGuard]
      },
      {
        path: AppRoutes.emissionsFactorsPage,
        component: EmissionsFactors,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.emissionsSourcesPage,
        component: EmissionsSources,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.resultsReportsPage,
        component: Results,
        canActivate: [authGuard]
      },
      {
        path: AppRoutes.resultsByMonthReportsPage,
        component: ResultsByMonth,
        canActivate: [authGuard]
      },
    ],
  },
  { path: '**', redirectTo: '' }
];
